<template>
    <div class="row justify-content-center">
        <div class="col-xl-10">
            <div class="uploader-container">
                <div v-if="sended" class="compress-result component-sended--wrapper">
                    <div class="row row-min-height align-items-center">
                        <div class="col-12 text-center" v-show="!sendError && !completed">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">{{ trans('tool-main.Processing text') }}</span>
                            </div>
                            <h4>{{ trans('tool-main.Processing text') }}</h4>
                            <button class="btn btn-lg btn-info cancel-btn_tool" @click="cancelSendTask()">
                                {{ trans('tool-main.Cancel') }}
                            </button>
                        </div>
                        <div class="col-12" v-if="!sendError && completed">
                            <h2 class="title compress-result_title">{{ trans('tool-main.File ready') }}</h2>

                            <div class="compress-result_action">
                                <div class="compress-result_action-group">
                                    <div class="compress-result_tools mt-4">
                                        <upload-block
                                            type-block="new-compact"
                                            :downloadUrl="downloadUrl"
                                            :dropboxFiles="dropboxFiles"
                                            :downloadFileInfo="downloadFileInfo"
                                            @onCancelDropbox="onCancelDropbox"
                                            @onErrorDropbox="onErrorDropbox"
                                            @onProgressDropbox="onProgressDropbox"
                                            @onSavedDropbox="onSavedDropbox"
                                            @markAsDownloaded="markAsDownloaded"
                                            ref="uploadBlock"/>

                                        <other-tools-block
                                            :task-id="this.taskId"
                                            :file-link="downloadUrl"
                                        ></other-tools-block>

                                        <div class="compress-result_tools-item">
                                            <button class="button compress-result_button-link"
                                                    @click="cancelSendTask()">
                                                {{ trans('tool-main.Keep Editing') }}
                                            </button>
                                            <button class="button compress-result_button-link" @click="reset()">
                                                {{ trans('tool-main.Start Over') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row align-items-stretch small_gutter">
                                <div class="col-lg-4 mt_25">
                                    <qr-block :url="downloadUrl"
                                              :task-id="taskId"
                                              :type="loaderType"
                                              :mode="loaderMode"
                                    ></qr-block>
                                </div>

                                <div class="col-lg-8 mt_25">
                                    <subscribe-block></subscribe-block>
                                    <share-icons-block></share-icons-block>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center" v-show="sendError">
                            <h5 class="mb-4" v-html="sendError"></h5>
                            <button class="btn btn-secondary" @click="cancelSendTask()">
                                {{ trans('tool-main.Back') }}
                            </button>
                            <button class="btn btn-outline-secondary ml-3" @click="reset()">
                                {{ trans('tool-main.Start Over') }}
                            </button>
                        </div>
                    </div>
                </div>
                <div v-if="files.length === 0" class="file-uploader--wrapper">
                    <file-uploader
                        :type="loaderType"
                        :mode="loaderMode"
                        :multiple="false"
                        :maxFiles="1"
                        @files-uploaded="updateFiles($event)"
                    />
                </div>

                <b-modal id="bv-modal-fullpages"
                         :modal-class="modalClass"
                         :body-class="bodyClass"
                         hide-header-close no-close-on-backdrop no-close-on-esc centered static>
                    <template v-slot:modal-title>
                        {{ trans('pdf/tool-sign.Title') }}
                    </template>
                    <div class="modal-body">
                        <pdf-preview v-if="files.length > 0" v-bind="{inputFiles: files, mode, selectable: true}" ref="viewer"
                                     @invalid-file="onInvalidFile"/>
                    </div>
                    <template v-slot:modal-footer>
                        <div class="row w-100">
                            <div class="col-md-6">
                                <p class="text-danger" v-show="showError">{{ trans('pdf/tool-sign.Info text') }}</p>
                            </div>
                            <div class="col-md-6 text-md-right">
                                <button type="button" class="btn btn-secondary" @click="reset">
                                    {{ trans('pdf/tool-sign.Cancel btn') }}
                                </button>
                                <button type="button" class="btn btn-primary" @click="checkAndSendTask()"
                                        :disabled="files.length < 1">{{ trans('pdf/tool-sign.Ok btn') }}
                                </button>
                            </div>
                        </div>
                    </template>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<style scoped>
.card-body {
    max-height: 500px;
    overflow-x: auto;
}
</style>

<script>
import markAsDownloaded from '../mixins/mark-as-downloaded.js';
import baseProcessing from '../mixins/base-processing.js';

export default {
    mixins    : [
        markAsDownloaded,
        baseProcessing,
    ],
    components: {
        'share-icons-block': () => import(/* webpackChunkName: 'result-blocks' */ '../shared/ShareIconsBlock'),
        'subscribe-block'  : () => import(/* webpackChunkName: 'result-blocks' */ '../shared/SubscribeBlock'),
        'other-tools-block': () => import(/* webpackChunkName: 'result-blocks' */ '../shared/OtherToolsBlock'),
        'pdf-preview'      : () => import(/* webpackChunkName: 'pdf' */ './elements/PDFFullPreview.vue'),
        'file-uploader'    : () => import(/* webpackChunkName: 'fileuploader' */ '../uploader/FileUploader.vue'),
        'upload-block'     : () => import(/* webpackChunkName: 'uploadBlock' */ '../uploader/UploadBlock.vue'),
        'qr-block'         : () => import(/* webpackChunkName: 'qr-block' */ '../shared/QrBlock.vue'),
    },
    data() {
        return {
            files      : [],
            mode       : 'pages',
            loaderType : 'pdf',
            loaderMode : 'sign',
            showError  : false,

            needShowFullPagesModal: false,
            modalClass            : 'extra-large-modal page-width-pdf',
            bodyClass             : 'centered-modal',
        }
    },
    watch  : {
        needShowFullPagesModal(newValue) {
            if (newValue) {
                this.$bvModal.show('bv-modal-fullpages');
                freestar.deleteStickyFooter();
            } else {
                this.$bvModal.hide('bv-modal-fullpages');
            }
        },
        sended(newValue) {
            if (newValue) {
                this.needShowFullPagesModal = false;
                this.showError = false;
            }
        },
    },
    methods: {
        updateFiles(files) {
            this.files = files;
            if (this.files.length > 0) {
                this.needShowFullPagesModal = true;
            }
        },

        onInvalidFile(file_id) {
            let index = this.files.findIndex(file => file.file_id == file_id);

            if (index > -1) {
                this.files.splice(index, 1);
            }
        },

        checkAndSendTask() {
            let pages = this.$refs.viewer.getPagesInfo();

            if (pages.length > 0) {
                this.showError = false;
                Vue.nextTick(() => this.sendTask());
            } else {
                this.showError = true;
            }
        },

        prepareTaskData() {
            return {
                files: this.files,
                pages: this.$refs.viewer.getPagesInfo(),
                mode : this.loaderMode,
            };
        },

        onSuccessSend(response) {
            this.needShowFullPagesModal = false;
        },

        onErrorSend(response) {
            this.needShowFullPagesModal = false;
        },

        afterReset() {
            // default values
            this.files = [];
            this.needShowFullPagesModal = false;
            this.showError = false;
        },

        afterCancel() {
            this.showError = false;
            Vue.nextTick(() => this.needShowFullPagesModal = true);
        },
        async checkSelected() {
            await this.getSelectedFile();
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.checkSelected();
        });
    }
}
</script>
